// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N4a5","content":"styles_content__21hTj"};